import { render, staticRenderFns } from "./ArrowDownAvatar.vue?vue&type=template&id=c992f5bc&scoped=true&"
var script = {}
import style0 from "./ArrowDownAvatar.vue?vue&type=style&index=0&id=c992f5bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c992f5bc",
  null
  
)

export default component.exports